import { Query } from '@shared/utils';

interface FixOptions {
    initialRadioOption: string;
    allowedValues: string[];
    query: Query;
    queryName: string | undefined;
}

export function fixRadioFilterQuery(options: FixOptions): string {
    const { initialRadioOption, allowedValues, query, queryName } = options;

    if (queryName) {
        let queryRadio = query[queryName];
        if (typeof queryRadio === 'boolean') {
            queryRadio = `${queryRadio}`;
        } else if (typeof queryRadio === 'object' || typeof queryRadio === 'undefined') {
            queryRadio = initialRadioOption;
        }
        if (~allowedValues.indexOf(queryRadio)) {
            return queryRadio;
        } else {
            return initialRadioOption;
        }
    } else {
        return initialRadioOption;
    }
}
